import React from 'react';
import { useSelector } from 'react-redux';
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';

import Authorization from 'components/AdminNew/HousecallEmployees/Authorization';
import AuthorizationPermission from 'components/AdminNew/Models/AuthorizationPermissions';
import { getPaywallSpinnerState } from 'components/PayWall/Redux/Selectors';

import { CIRCULAR_PROGRESS_BUTTON_SIZE, useButtonProgressStyles } from './PayWallDialog';
import { PayWallSubmitTrigger } from './PayWallPaymentReviewDialog';

type Props = {
  onSubmit: () => void;
  isCurrentlyPaying: boolean;
  submitTrigger?: PayWallSubmitTrigger;
};

function UpdatePlanNoChargeButton({ onSubmit, submitTrigger, isCurrentlyPaying }: Props): JSX.Element {
  const loading = useSelector(getPaywallSpinnerState);
  const classes = useButtonProgressStyles({ circularProgressSize: CIRCULAR_PROGRESS_BUTTON_SIZE });

  return (
    <Box className={classes.wrapper} data-testid="update-plan-no-charge-button">
      <Button color="primary" variant="outlined" disabled={!isCurrentlyPaying || loading} onClick={onSubmit}>
        Update plan without charging
      </Button>
      {loading && submitTrigger === 'nocharge' && (
        <CircularProgress className={classes.buttonProgress} size={CIRCULAR_PROGRESS_BUTTON_SIZE} />
      )}
    </Box>
  );
}

export default Authorization(AuthorizationPermission.NO_CHARGE_BILLING)(UpdatePlanNoChargeButton);
